import { Button, Menu, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { Launch as LaunchIcon } from '@material-ui/icons';
import * as PropTypes from 'prop-types';
import React, { Component } from 'react';


export default class ReportMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  isRiskReport = (reportType) => {
    return Boolean(reportType.toLowerCase().includes('risk'));
  };

  render() {
    const { anchorEl } = this.state;
    const {
      classes,
      id,
      items,
      handleViewHtml,
      handleViewJson,
    } = this.props;

    return (
      <React.Fragment>
        <Button
          aria-owns={anchorEl ? id : null}
          aria-haspopup="true"
          onClick={this.handleOpen}
          variant="outlined"
        >
          View Reports
        </Button>
        <Menu
          id={id}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          disableAutoFocusItem
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          getContentAnchorEl={null}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Report Type</TableCell>
                <TableCell colSpan={2} style={{ textAlign: 'center' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                items.map(request => (
                  <TableRow key={`${request.requestId}-${request.reportType}`}>
                    <TableCell>{request.reportType}</TableCell>
                    {
                      !this.isRiskReport(request.reportType) && (
                        <TableCell>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {
                              handleViewHtml(request);

                              this.handleClose();
                            }}
                          >
                            HTML <LaunchIcon className={classes.marginLeft} />
                          </Button>
                        </TableCell>
                      )
                    }
                    <TableCell colSpan={this.isRiskReport(request.reportType) ? 2 : 1}>
                      <Button
                        color="secondary"
                        variant="contained"
                        onClick={() => {
                          handleViewJson(request);

                          this.handleClose();
                        }}
                      >
                        JSON <LaunchIcon className={classes.marginLeft} />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </Menu>
      </React.Fragment>
    );
  }
}

ReportMenu.propTypes = {
  id: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  handleViewHtml: PropTypes.func,
  handleViewJson: PropTypes.func,
  style: PropTypes.object,
};


// WEBPACK FOOTER //
// ./src/components/Account/SelectReportMenu.js